import { render, staticRenderFns } from "./ClassroomParticipants.vue?vue&type=template&id=34449d81&"
import script from "./ClassroomParticipants.vue?vue&type=script&lang=js&"
export * from "./ClassroomParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports